import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check, ShieldCheck, Smartphone, Star, Zap } from 'lucide-react';
const HIGHLIGHTS = ['6 tomos digitales', '5 bonos incluidos', 'Acceso inmediato', 'Actualizaciones incluidas'];
export function Hero() {
  return <section className="relative pt-5 pb-9 md:pt-10 md:pb-20 overflow-hidden bg-clinical-base" data-id="element-101" data-mp="4m8lmajdinjv">
      <div className="absolute inset-0 bg-grid-pattern opacity-40 pointer-events-none" data-id="element-102" data-mp="12a0kd8y2xwtk"></div>
      <div className="absolute bottom-0 right-0 w-[30rem] h-[30rem] bg-clinical-softer rounded-full blur-[140px] opacity-50 pointer-events-none" data-id="element-103" data-mp="xanqw5cpdri0"></div>

      <div className="relative max-w-[1240px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-104" data-mp="s9ggrzn38g86">
        <div className="grid grid-cols-1 lg:grid-cols-[1.05fr_1fr] gap-6 lg:gap-12 items-center" data-id="element-105" data-mp="nbexbdlr2ew6">
          <div className="flex flex-col items-center text-center lg:items-start lg:text-left" data-id="element-106" data-mp="3d2bjxpolizvj">
            <p className="text-[10px] sm:text-xs font-semibold tracking-[0.22em] uppercase text-clinical-mid mb-3" data-id="element-107" data-mp="381e61pamcrzu">
              Atlas Clínico · Mega Pack Enfermería
            </p>

            <motion.h1 initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            ease: [0.23, 1, 0.32, 1]
          }} className="font-heading font-black leading-[1.1] mb-3 md:mb-4 text-[1.65rem] sm:text-[2.3rem] md:text-[2.7rem] lg:text-[3rem] text-clinical-deep tracking-tight uppercase" data-id="element-108" data-mp="3o7vjnj38jlwr">
              Ten claro qué valorar, qué priorizar y cómo actuar{' '}
              <span className="accent-italic font-bold normal-case" data-id="element-109" data-mp="2vi53l4i1m9y0">
                frente a cada situación clínica.
              </span>
            </motion.h1>

            <p className="text-[14.5px] md:text-lg text-clinical-ink mb-5 max-w-xl leading-relaxed font-medium" data-id="element-110" data-mp="2hlj9m4lat58v">
              Una guía práctica de consulta que reúne valoración,
              procedimientos, farmacología, urgencias y razonamiento clínico
              para{' '}
              <span className="font-bold text-clinical-deep" data-id="element-111" data-mp="na0ab23m59fr">
                conectar la teoría con la práctica
              </span>
              .
            </p>

            {/* Mobile product visual */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.96
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.08,
            duration: 0.3,
            ease: [0.23, 1, 0.32, 1]
          }} className="lg:hidden relative w-full max-w-[390px] mb-5" data-id="element-112" data-mp="db2dzczy4bm7">
              <img src="https://cdn.magicpatterns.com/uploads/j6sRYcK5X4hdn124VLpYBV/Copia_de_Diseno_sin_titulo.png" alt="Mega Pack Enfermería — 6 tomos digitales" width={720} height={540} loading="eager"
            // @ts-ignore — valid HTML attribute, React supports it
            fetchpriority="high" decoding="async" className="relative w-full h-auto drop-shadow-[0_20px_44px_rgba(11,42,74,0.26)]" data-id="element-113" data-mp="3lt73mli5bhrm" />
            </motion.div>

            <p className="mb-5 flex items-center gap-2.5 text-[11.5px] sm:text-xs font-bold uppercase tracking-[0.14em] text-clinical-deep" data-id="element-114" data-mp="2fzss4ousp2q0">
              <span aria-hidden="true" className="h-[2px] w-6 flex-shrink-0 bg-clinical-accent" data-id="element-115" data-mp="2kxudxhjlvg56" />
              De la valoración a la acción, paso a paso.
            </p>

            <ul className="grid grid-cols-2 gap-x-3 gap-y-2 w-full max-w-[420px] lg:max-w-none mb-5 text-left" data-id="element-116" data-mp="2tz1ykwt78igs">
              {HIGHLIGHTS.map(item => <li key={item} className="flex items-start gap-2 text-[13px] md:text-sm font-semibold text-clinical-deep" data-id="element-117" data-mp="zl0yk8lwxpf4">
                  <span className="mt-0.5 flex-shrink-0 w-4 h-4 rounded-full bg-clinical-deep flex items-center justify-center" data-id="element-118" data-mp="3vhp59x1jccpz">
                    <Check className="w-2.5 h-2.5 text-white" strokeWidth={3} data-id="element-119" data-mp="e9tphn8vfr08" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="w-full flex flex-col items-center lg:items-start" data-id="element-120" data-mp="3hq0srsndjm8h">
              <a href="#pricing" className="group inline-flex items-center justify-center gap-2.5 bg-clinical-cta hover:bg-clinical-ctaHover text-white font-bold text-[14.5px] sm:text-lg px-6 sm:px-10 py-4 sm:py-5 rounded-full transition-[transform,background-color,box-shadow] duration-200 ease-out hover:scale-[1.02] active:scale-[0.98] shadow-[0_14px_36px_rgba(15,98,254,0.4)] w-full max-w-[420px] sm:w-auto mb-3 uppercase tracking-[0.03em] text-center touch-manipulation" data-id="element-121" data-mp="3hnxrgcgru6og">
                Quiero acceder a Atlas Clínico
                <ArrowRight size={19} className="transition-transform duration-200 ease-out group-hover:translate-x-1 flex-shrink-0" data-id="element-122" data-mp="19h2mi7je6zzn" />
              </a>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-x-2.5 gap-y-1 text-[11px] sm:text-xs text-clinical-ink/80 font-medium" data-id="element-123" data-mp="zmaq371jqj6g">
                <span className="flex items-center gap-1.5" data-id="element-124" data-mp="1sa6lm8fdq51n">
                  <Zap size={12} className="text-clinical-mid" data-id="element-125" data-mp="1x881yllf7q9f" />
                  Acceso inmediato
                </span>
                <span className="text-clinical-line" data-id="element-126" data-mp="1j905i0gn6w8x">·</span>
                <span className="flex items-center gap-1.5" data-id="element-127" data-mp="1jata7a7p36ea">
                  <Smartphone size={12} className="text-clinical-mid" data-id="element-128" data-mp="1n8qymatn5ogm" />
                  Pago único
                </span>
                <span className="text-clinical-line" data-id="element-129" data-mp="7s0ed8616ngh">·</span>
                <span className="flex items-center gap-1.5" data-id="element-130" data-mp="bvyb5c7vvm6d">
                  <ShieldCheck size={12} className="text-clinical-mid" data-id="element-131" data-mp="2ehkfnb6i0pc4" />
                  Garantía de 7 días
                </span>
              </div>

              <div className="mt-4 inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-clinical-line bg-white" data-id="element-132" data-mp="29jsctm4bfit5">
                <Star size={12} className="fill-clinical-accent text-clinical-accent" data-id="element-133" data-mp="24po8lamfpovr" />
                <span className="text-xs font-semibold text-clinical-deep" data-id="element-134" data-mp="1vrm06a0dftyg">
                  4.9/5
                </span>
                <span className="text-clinical-line" data-id="element-135" data-mp="1qr6mfhc6gkfy">·</span>
                <span className="text-[11px] sm:text-xs font-medium text-clinical-ink" data-id="element-136" data-mp="1lsmxd82aesjd">
                  Estudiantes en prácticas y enfermeros junior
                </span>
              </div>
            </div>
          </div>

          {/* Desktop product visual */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.08,
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="hidden lg:flex relative justify-end w-full" data-id="element-137" data-mp="3g4tl16cdb1sk">
            <img src="https://cdn.magicpatterns.com/uploads/j6sRYcK5X4hdn124VLpYBV/Copia_de_Diseno_sin_titulo.png" alt="Mega Pack Enfermería — 6 tomos digitales" width={720} height={540} loading="eager"
          // @ts-ignore — valid HTML attribute, React supports it
          fetchpriority="high" decoding="async" className="relative w-full max-w-[620px] h-auto drop-shadow-[0_28px_56px_rgba(11,42,74,0.28)] animate-float-slow" data-id="element-138" data-mp="1aukl4x64x3b" />
          </motion.div>
        </div>
      </div>
    </section>;
}